export default __webpack_public_path__ + "static/ehv-hair-repair-d8262522e457d917e58eab1492a9f9c5.webp";